// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_D4z","cls2":"RelatedWorksCard-cls2_TSP RelatedWorksCard-cls1_D4z"};